<ul class="flex flex-justify-center w-12 w-8-s w-8-m">
  @if (!isSamples) {
    <li class="flex flex-top flex-justify-center"
      >
      <a class="center col-1 cursor-pointer"
        routerLink="/basket">
        <div class="progress-dot bg-col-1"></div>
        <p class="progress-label">
          <span class="progress-label-content pt inline-block"
          sizeClass="SM: c1, XL: p2">{{'Basket' | translate}}</span>
        </p>
      </a>
    </li>
  }
  @for (step of steps; track stepTrackFn($index, step); let isFirst = $first) {
    <li
      class="flex flex-top flex-justify-center">
      @if (!isSamples || !isFirst) {
        <div class="progress-bar"
        [ngClass]="ifDotActive(step) ? 'bg-col-1' :'bg-col-4'"></div>
      }
      <div class="center"
        [ngClass]="ifDotActive(step) ? 'col-1' :'col-4'"
        [class.cursor-pointer]="isEnabled(step) || ifDotActive(step)"
        (click)="goTo(step)">
        <div class="progress-dot"
        [ngClass]="ifDotActive(step) ? 'bg-col-1' :'bg-col-4'"></div>
        <p class="progress-label">
          <span class="progress-label-content pt inline-block"
          sizeClass="SM: c1, XL: p2">{{step.stepTitle}}</span>
        </p>
      </div>
    </li>
  }
</ul>